module.exports = __webpack_public_path__ + "static/media/door08.73be11d3.png";